import SeriesData from '@/types/series-data';
import { ProposalFieldDAO } from './ProposalFieldDAO';
import { TIME_SERIES } from './constants';
import ProposalTableRowData from '@/types/proposal-table-row-data';
import Timestamp from '@/types/timestamp';
import ComparisonItem from '@/types/comparison-item';
import BMOGIFItem from '@/types/bmo-gif/bmo-gif-item';

// BaseItemDAO /////////////////////////////////////////////////////

export abstract class BaseItemDAO {
  // this is a 2 dimensional array to support multiple data set per item.
  protected proposalFieldDAOs: ProposalFieldDAO[][];

  constructor() {
    this.proposalFieldDAOs = [];
  }

  getFieldDAOCount(): number {
    return this.proposalFieldDAOs.length;
  }

  getFieldDAOs(col: number = 0): ProposalFieldDAO[] {
    if (this.proposalFieldDAOs.length === 0) {
      return [];
    }

    if (col < this.proposalFieldDAOs.length) {
      return this.proposalFieldDAOs[col];
    }

    return this.proposalFieldDAOs[0];
  }

  getFieldDAO(index: number, col: number = 0): ProposalFieldDAO {
    const column: ProposalFieldDAO[] = this.getFieldDAOs(col);
    return column[index];
  }

  getSeriesData(): Array<SeriesData> {
    const data: Array<SeriesData> = [];

    for (const fieldDAO of this.getFieldDAOs()) {
      const n: number = parseFloat(fieldDAO.value);
      const yValue = Number.isNaN(n) ? null : n;

      data.push({ name: fieldDAO.label, y: yValue, key: fieldDAO.key });
    }

    return data;
  }

  addFieldDAO(field: ProposalFieldDAO, col: number = 0): void {
    while (this.proposalFieldDAOs.length <= col) {
      this.proposalFieldDAOs.push([]);
    }

    this.proposalFieldDAOs[col].push(field);
  }

  getTableColumnData(): ProposalTableRowData[] {
    return this.proposalFieldDAOs.map(proposalFieldDAOs => ({ data: proposalFieldDAOs }));
  }
}
// BMOGIFItemDAO /////////////////////////////////////////////////////

export class BMOGIFItemDAO extends BaseItemDAO {
  item: BMOGIFItem;

  constructor(item: BMOGIFItem) {
    super();

    this.item = item;
  }
}

// ComparisonItemDAO /////////////////////////////////////////////////////

export class ComparisonItemDAO extends BaseItemDAO {
  item: ComparisonItem;

  constructor(item: ComparisonItem) {
    super();

    this.item = item;
  }

  getSeries(seriesName: 'WEEKLY_ROLLING' | 'MONTHLY_ROLLING'): [Timestamp, number][] {
    const { performance } = this.item;

    switch (seriesName) {
      case TIME_SERIES.WEEKLY_ROLLING: {
        return (performance.rolling && performance.rolling.weekly) || [];
      }
      case TIME_SERIES.MONTHLY_ROLLING: {
        return (performance.rolling && performance.rolling.monthly) || [];
      }
      default: {
        return [];
      }
    }
  }
}
